<template>
	<!-- <li 
		v-on:mouseover="mouseOverMenu()"
		v-on:mouseleave="mouseLeaveMenu()"
	> -->
	<li class="__sidebar-menu">
		<!-- --------------- CÓ SUB ITEM---------- -->
		<div
			class="the-sidebar-item has-subitem"
			:class="{ mn_active: data.isOpen }"
			v-if="hasSubItems(data) && checkChild(data)"
			@click="getId(data.id)"
		>
			<span class="the-sidebar-item-icon-wrap">
				<img class="the-sidebar-item-icon" :src="getPathImage(path, data.icon)" :alt="data.icon">
				<!-- <i
					class="the-sidebar-item-icon"
					:class="`fz-16 fa-solid ${data.icon}`"
					v-if="data.icon"
				></i> -->
			</span>
			<span class="the-sidebar-item-label">{{ data.label }}</span>
			
		</div>
		<el-collapse-transition>
			<ul class="the-sidebar-sub-item" v-if="hasSubItems(data)" v-show="data.isOpen">
				<!-- <p v-if="isOpen" class="the-sidebar-item-sm-label">{{data.label}}</p> -->
				<li v-for="(subitem, index) of data.subItems" :key="index">
					<router-link :to="subitem.link"
					v-show="(dataPermission !== null && dataPermission.length > 0) ? dataPermission.includes(subitem.permission) : false"
					class="the-sidebar-item-subitem"
					:class="{'router-link-exact-active': checkIsOrderActive(subitem) }">
						{{ subitem.label }}
					</router-link>
				</li>
			</ul>
		</el-collapse-transition>

		<!-- ---------------KHONG SUB ITEM---------- -->
		<router-link
			class="the-sidebar-item"
			:to="data.link"
			v-if="!hasSubItems(data) && data.link"
			v-show="(dataPermission !== null && dataPermission.length > 0) ? ((data.listPermission && data.listPermission.length > 0) ? dataPermission.includes(data.listPermission[0]) : false) : false"
			@click="getId(data.id)"
		>
			<span class="the-sidebar-item-icon-wrap">
				<img class="the-sidebar-item-icon" :src="getPathImage(path, data.icon)" :alt="data.icon">
				<!-- <i
					class="the-sidebar-item-icon"
					:class="`fz-16 fa-solid ${data.icon}`"
					v-if="data.icon"
				></i> -->
			</span>
			<span class="the-sidebar-item-label">
				{{ data.label }}
			</span>
			
		</router-link>

		<!-- ---------------TRỎ LINK SANG WEB KHÁC (NEXTLEND,...)---------- -->
		<a
			class="the-sidebar-item"
			v-if="!hasSubItems(data) && data.href"
			target="_blank"
			:href="data.href"
			@click="getId(data.id)"
		>
			<span class="the-sidebar-item-icon-wrap">
				<img class="the-sidebar-item-icon" :src="getPathImage(path, data.icon)" :alt="data.icon">
				<!-- <i
					class="the-sidebar-item-icon"
					:class="`fz-16 fa-solid ${data.icon}`"
					v-if="data.icon"
				/> -->
			</span>
			<span class="the-sidebar-item-label">{{ data.label }}</span>
			
		</a>
	</li>
</template>

<script>
export default {
	props: {
		data: {
			type: Object,
		},
	},
	data() {
		return {
			isOpen: false,
			isActive: false,
			dataPermission: JSON.parse(localStorage.getItem('dataPermission')),
			path: "assets/menu-icons/"
		};
	},
	methods: {
		hasSubItems(item) {
			return item.subItems !== undefined ? item.subItems.length > 0 : false;
		},
		checkChild (child) {
			if (this.dataPermission && child.listPermission) {
				const childPer = []
				child.listPermission.map((item) => {
				const check = (this.dataPermission !== null && this.dataPermission.length > 0) ? this.dataPermission.includes(item) : false
				if (check) {
					childPer.push(item)
				}
				})

				if (childPer.length === 0) {
				return false
				} else {
				return true
				}
			} else {
				return true
			}
		},
		getId(id) {
			this.$emit("getID", id)
		},
		checkIsOrderActive(item) {
			return item.link == "/orders/" && this.$route.query.page
		}
	},
};
</script>

<style lang="scss" scoped>

.the-sidebar-item {
	height: 54px;
	box-sizing: border-box;
	padding: 12px 24px 12px 24px;
	display: flex;
	place-items: center;
	color: #000;
	font-weight: 500;
	position: relative;
	transition: all 0.2s;

	&.the-sidebar-sub-item {
		-webkit-transition: all 0.5s;
		-moz-transition: all 0.5s;
		-ms-transition: all 0.5s;
		transition: all 0.5s;
	}

	&.has-subitem {
		color: #000;
	}

	&.has-subitem::before {
		content: "";
		position: absolute;
		top: auto;
		bottom: auto;
		right: 16px;
		width: 24px;
		height: 24px;
		transform: rotate(0deg);
		transition: ease-in-out 0.35s;

		background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjYyODcgMTYuMTU3NkMxMS44NDcxIDE2LjM3NiAxMi4xNTI5IDE2LjM3NiAxMi4zNzEzIDE2LjE1NzZMMTguODM2MiA5LjczNjM1QzE5LjA1NDYgOS41NjE2MiAxOS4wNTQ2IDkuMjEyMTcgMTguODM2MiA4Ljk5Mzc2TDE3Ljk2MjYgOC4xNjM4MUMxNy43ODc4IDcuOTQ1NCAxNy40Mzg0IDcuOTQ1NCAxNy4yMiA4LjE2MzgxTDEyLjAyMTggMTMuMzE4M0w2Ljc4MDAzIDguMTYzODFDNi41NjE2MiA3Ljk0NTQgNi4yNTU4NSA3Ljk0NTQgNi4wMzc0NCA4LjE2MzgxTDUuMTYzODEgOC45OTM3NkM0Ljk0NTQgOS4yMTIxNyA0Ljk0NTQgOS41NjE2MiA1LjE2MzgxIDkuNzM2MzVMMTEuNjI4NyAxNi4xNTc2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==")
			no-repeat center center;
	}

	&.has-subitem:hover::before {
		background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02LjYyODcxIDguMTU3NTdDNi44NDcxMSA4LjM3NTk4IDcuMTUyODkgOC4zNzU5OCA3LjM3MTI5IDguMTU3NTdMMTMuODM2MiAxLjczNjM1QzE0LjA1NDYgMS41NjE2MiAxNC4wNTQ2IDEuMjEyMTcgMTMuODM2MiAwLjk5Mzc2TDEyLjk2MjYgMC4xNjM4MDdDMTIuNzg3OCAtMC4wNTQ2MDIyIDEyLjQzODQgLTAuMDU0NjAyMiAxMi4yMiAwLjE2MzgwN0w3LjAyMTg0IDUuMzE4MjVMMS43ODAwMyAwLjE2MzgwN0MxLjU2MTYyIC0wLjA1NDYwMjIgMS4yNTU4NSAtMC4wNTQ2MDIyIDEuMDM3NDQgMC4xNjM4MDdMMC4xNjM4MDcgMC45OTM3NkMtMC4wNTQ2MDIyIDEuMjEyMTcgLTAuMDU0NjAyMiAxLjU2MTYyIDAuMTYzODA3IDEuNzM2MzVMNi42Mjg3MSA4LjE1NzU3WiIgZmlsbD0iIzNFNjlGNiIvPgo8L3N2Zz4K") no-repeat center center;
	}

	// &.has-subitem.mn_active {
	// 	background: rgba(62, 105, 246, 0.06);
	// 	color: #3e69f6;

	// 	&::before {
	// 		background: url("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iOSIgdmlld0JveD0iMCAwIDE0IDkiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02LjYyODcxIDguMTU3NTdDNi44NDcxMSA4LjM3NTk4IDcuMTUyODkgOC4zNzU5OCA3LjM3MTI5IDguMTU3NTdMMTMuODM2MiAxLjczNjM1QzE0LjA1NDYgMS41NjE2MiAxNC4wNTQ2IDEuMjEyMTcgMTMuODM2MiAwLjk5Mzc2TDEyLjk2MjYgMC4xNjM4MDdDMTIuNzg3OCAtMC4wNTQ2MDIyIDEyLjQzODQgLTAuMDU0NjAyMiAxMi4yMiAwLjE2MzgwN0w3LjAyMTg0IDUuMzE4MjVMMS43ODAwMyAwLjE2MzgwN0MxLjU2MTYyIC0wLjA1NDYwMjIgMS4yNTU4NSAtMC4wNTQ2MDIyIDEuMDM3NDQgMC4xNjM4MDdMMC4xNjM4MDcgMC45OTM3NkMtMC4wNTQ2MDIyIDEuMjEyMTcgLTAuMDU0NjAyMiAxLjU2MTYyIDAuMTYzODA3IDEuNzM2MzVMNi42Mjg3MSA4LjE1NzU3WiIgZmlsbD0iIzNFNjlGNiIvPgo8L3N2Zz4K") no-repeat center center;
	// 		transform: rotate(180deg);
	// 		transition: ease-in-out 0.35s;
	// 	}

	// 	.the-sidebar-item-icon-wrap {
	// 		background: #3e69f6;

	// 		i.the-sidebar-item-icon {
	// 			color: #fff;
	// 		}
	// 	}
	// }

	&:hover {
		background-color: #f6f6f6;
		color: #3e69f6;
		cursor: pointer;
		z-index: 99;
	}

	&.item-active {
		color: #3e69f6;
		background: rgba(62, 105, 246, 0.05);
	}

	&.current {
		color: #3e69f6;
		background: #f5f8ff;
	}

	&-icon-wrap {
		// width: 36px;
		// height: 36px;
		place-content: center center;
		border-radius: 50%;
	}

	&-icon {
		display: flex;
		place-content: center;
		place-items: center;
	}

	&-label {
		margin-left: 12px;
	}

	&-sm-label,
	&-subitem {
		height: 44px;
		box-sizing: border-box;
		padding: 16px 24px 16px 64px;
		display: flex;
		place-items: center;
		color: #000;
		font-weight: 500;
		&:hover {
			background: #f6f6f6;
			color: #3e69f6;
		}
		&.current {
			color: #3e69f6;
			background: #f5f8ff;
		}
	}
}
</style>

<style lang="scss">
.the-sidebar-item.router-link-active, .the-sidebar-item-subitem.router-link-exact-active {
  background: rgba(62, 105, 246, 0.06);
	color: #3e69f6;
	.the-sidebar-item-icon {
		filter: invert(31%) sepia(69%) saturate(3429%) hue-rotate(221deg) brightness(103%) contrast(93%);
	}
}
.the-sidebar-item-icon {
	width: 20px !important;
	height: 20px !important;
}
</style>
